/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: collaborators-resource-factory.ts
 *
 * Created by sjacobs on 2/2/18.
 */

'use strict';


angular.module('prism-ui.components.data').factory('CollaboratorsResourceFactory', function ($resource: any, EndPointService: any) {
    return $resource(EndPointService.collaboratorsEndPoint, {},
        {
            all: {
                method: 'GET',
                fetchOffset: '@fetchOffset',
                fetchLimit: '@fetchLimit',
                searchString: '@searchString',
                includeHidden: '@includeHidden',
                url: EndPointService.collaboratorsEndPoint,
                isArray: true
            },
            byId: {
                method: 'GET',
                params: {
                    id: '@id'
                },
                url: `${EndPointService.collaboratorsEndPoint}/:id`,
                isArray: false
            },
            roles: {
                method: 'GET',
                url: `${EndPointService.collaboratorsEndPoint}/:id/roles`,
                isArray: true
            },
            getRole: {
                method: 'GET',
                url: `${EndPointService.collaboratorsEndPoint}/roles/:id`,
                isArray: false
            },
            saveRole: {
                method: 'POST',
                url: `${EndPointService.collaboratorsEndPoint}/roles/:id`,
                isArray: false
            },
            updateRole: {
                method: 'PUT',
                url: `${EndPointService.collaboratorsEndPoint}/roles`,
                isArray: false
            },
            deleteRole: {
                method: 'DELETE',
                url: `${EndPointService.collaboratorsEndPoint}/roles/:id`,
                isArray: false
            },
            save: {
                method: 'POST',
                url: EndPointService.collaboratorsEndPoint,
                isArray: false
            },
            update: {
                method: 'PUT',
                params: {
                    id: '@id'
                },
                url: `${EndPointService.collaboratorsEndPoint}/:id`,
                isArray: false
            },
            delete: {
                method: 'DELETE',
                params: {
                    id: '@id'
                },
                url: `${EndPointService.collaboratorsEndPoint}/:id`,
                isArray: false
            }
        });
});
